import React from 'react';
import useGlobal from '../../store';
import ActivityFeedItem from './ActivityFeedItem';


const ActivityFeed = (props) => {

    const [activity] = useGlobal(
        state => state.activity
    );

    const feedItems = activity.map(item => <ActivityFeedItem key={item.date} {...item}></ActivityFeedItem>);

    return (
        <div className="kt-portlet kt-portlet--height-fluid">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">Recent Activity</h3>
                </div>
            </div>
            <div className="kt-portlet__body">
                <div className="kt-scroll ps ps--active-y" style={{maxHeight: "445px",overflow: "auto"}}>
                    <div className="kt-timeline">
                        {feedItems}
                    </div>
                </div>
            </div>
        </div>);
}
export default ActivityFeed;